function generateClipPath(minimumIncrement, maximumIncrement, minmumIndent, maximumIndent, width, height){
    let string = 'polygon( 0% 0%';

    let x = 0;
    let y = 0;

    // let minimumIncrement = 0;
    // let maximumIncrement = 4;

    // let minmumIndent = 0;
    // let maximumIndent = 3;

    //top left to top right
    while ( x < width) {
        let xIncrement = randomIntFromInterval(minimumIncrement, maximumIncrement);
        let indent = randomIntFromInterval(minmumIndent, maximumIndent);
        x = x + xIncrement;
        string = string + `, ${x}px ${indent}px`;
    }
    string = string + ', 100% 0%';
    //top right to bottom right
    //while y <
    while ( y < height) {
        let yIncrement = randomIntFromInterval(minimumIncrement, maximumIncrement);
        let indent = randomIntFromInterval(minmumIndent, maximumIndent);
        y = y + yIncrement;
        string = string + `, calc(100% - ${indent}px) ${y}px`;
    }
    string = string + ', 100% 100%';
    //bottom right to bottom left
    //while x > 0
    while ( x > 0) {
        let xIncrement = randomIntFromInterval(minimumIncrement, maximumIncrement);
        let indent = randomIntFromInterval(minmumIndent, maximumIndent);
        x = x - xIncrement;
        string = string + `, ${x}px calc(100% - ${indent}px)`;
    }
    string = string + ', 0% 100%';
    //bottom left to top left
    //white y > 0
    while ( y > 0) {
        let yIncrement = randomIntFromInterval(minimumIncrement, maximumIncrement);
        let indent = randomIntFromInterval(minmumIndent, maximumIndent);
        y = y - yIncrement;
        string = string + `, ${indent}px ${y}px`;
    }
    string = string + ')';
    return string
}

function randomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export default generateClipPath;